import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImageLightIcon from 'Components/icons/ImageLightIcon';
import Button from 'Components/Button';
export class AgImageIcon extends Component {
    constructor(props) {
        super(props);
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }

    render() {
        return (
            <span key={this.props.node.rowIndex} className="image-icon">
                <Button
                    action={this.invokeParentMethod}
                    category="image-tool toggled"
                    icon={ImageLightIcon}
                    iconDirection="left"
                />
            </span>
        );
    }

    invokeParentMethod() {
        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.rowActionClick && this.props.context.componentParent.props.rowActionClick(this.props.node.rowIndex, 'OPEN_CASE');
    };
}
AgImageIcon.propTypes = {
    context: PropTypes.object,
    node: PropTypes.object,
    rowIndex: PropTypes.number,
};

export default AgImageIcon;